import * as PrehledPlatbaTyp from 'mc/lib/api/gen/proxioapi/PrehledPlatbaTyp';

export function isVypisRadek(platba) {
    return platba.typ === PrehledPlatbaTyp.BANKOVNI_VYPIS_RADEK
}

export function isHlavickaPlatba(platba) {
    return platba.typ === PrehledPlatbaTyp.HLAVICKA_PLATBA
}

export function isVraceniEnabled(platba) {
    return !platba.vyrazeno && platba.castkaPlatby > 0;
}

export function isVyrovnaniEnabled(platba) {
    return !platba.vyrazeno && platba.castkaZbyvaVyrovnat != 0
}

export function isVyrovnaniNenulove(platba) {
    return !platba.vyrazeno && platba.castkaZbyvaVyrovnat != 0
}
